import { render } from "./App.vue?vue&type=template&id=2805b93d"
const script = {}

import exportComponent from "E:\\devops.aliyun\\liangting\\liangting_pms_wap\\pms.wap\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__